import {
  IGeometryModel,
  MarkerModelBase,
} from '@types-custom/models/business/marker.model';
import { Icon } from '@types-custom/models/ui/icon-model';

export interface IPropsMatrixCameraODModel {
  id: string;
  address: string;
  url: string;
  name: string;
  cameraType: string;
  status: string;
  description: string;
  title: string;
  icon: Icon;
  markerPopupText: string;
  coordinates : any[];
  cameraNlId: string;
}

export class MatrixODCameraModel extends MarkerModelBase {
  static className = 'MatrixODCameraModel';
  classProperties: IPropsMatrixCameraODModel;

  constructor(props: IPropsMatrixCameraODModel, geometry: IGeometryModel) {
    super(geometry, MatrixODCameraModel.className);
    this.classProperties = props;
  }
}
